import React, { memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from '@emotion/styled'

const BWIcon = ({ faIconCss, icon, disabled, ...restProps }) => {
  const renderIcon = () => {
    return (
      <FaIcon icon={icon} disabled={disabled} css={faIconCss} {...restProps} />
    )
  }

  return renderIcon()
}

export default memo(BWIcon)

const iconStyles = ({ theme: { colors }, iconColor, disabled }) => `
  color: ${disabled ? colors.liteWhite : colors[iconColor]};
`

const FaIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'iconColor'
})(iconStyles)
